// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HParx","colMin":"styles_colMin__343E6"};